import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
import { IRowCommandEventArgs } from "../../../records/grids/controller";
import { Record } from "../../../records/server/crud";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";
import { $confirm } from "../../../../@custom_types/confirm";
import { escapeAngularExpressionValueGetter } from "../../../records/grids/cells/valueGetters";

const gridId = Symbol("main.processes.notification");
export class ProcessNotificationComponentController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
    "$confirm",
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  templateId = {};
  processActions!: any;

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
    private readonly $confirm: $confirm
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/process/notification"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "edit",
        headerName: "edit",
        iconClass: "fa fa-pencil text-primary",
        stateExpression: ".edit({actionId: data.Id})",
      }),
      columnDefinitionService.getCommandColDef({
        headerName: "delete",
        name: "delete",
        iconClass: "fa fa-trash text-primary",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "SlotcheckEmailTemplateName",
        header: "Template",
      }),
      columnDefinitionService.getStringColDef({
        field: "MailSubject",
        header: "Subject",
        valueGetter: escapeAngularExpressionValueGetter,
      }),
      columnDefinitionService.getStringColDef({
        field: "MailBody",
        header: "Body",
        valueGetter: escapeAngularExpressionValueGetter,
      }),
      columnDefinitionService.getStringColDef({
        field: "GroupId",
        header: "Group",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProcessId",
        header: "Process",
      }),
      columnDefinitionService.getStringColDef({
        field: "StateId",
        header: "State",
      }),
      columnDefinitionService.getStringColDef({
        field: "NotificationType",
        header: "Type",
        filter: new FilterProvider("NotificationType", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              queryFieldNames: ["NotificationType"],
              options: [
                {
                  display: "Entry",
                  value: "Entry",
                },
                {
                  display: "Exit",
                  value: "Exit",
                },
              ],
            })
          )
          .getGridFilterFactory(),
      }),
    ];
  }

  $onInit(): void {}

  onItemCommand(args: IRowCommandEventArgs<Record>) {
    switch (args.commandName) {
      case "delete":
        const actionId = args.data.Id;
        this.$confirm({
          text: "Are you sure you want to delete this action?",
        }).then(() =>
          this.serverUtility
            .sendApiRequest({
              method: "DELETE",
              url: `api/process/notification/${actionId}`,
            })
            .then(() => {
              args.gridApi.onNewDatasource();
            })
        );
        break;
    }
  }
}
